import React, { useEffect, useState } from 'react'

import Dialog from '@react/react-spectrum/Dialog'
import { Form, FormItem } from '@react/react-spectrum/Form'
import Textfield from '@react/react-spectrum/Textfield'

import DealRegistrationInput from './DealRegistrationInput'

export const DuplicateProjectDialog = ({ projectId, title, drNumber, onSubmit, ...otherProps }) => {
  const [state, setState] = useState({ projectId, title, drNumber })

  return (
    <Dialog
      {...otherProps}
      title='Duplicate project'
      onConfirm={() => onSubmit(state)}
      confirmLabel='Create'
      cancelLabel='Cancel'
      role='dialog'
    >
      <DuplicateProjectForm projectId={projectId} title={title} drNumber={drNumber} onChange={setState} />
    </Dialog>
  )
}

export const DuplicateProjectForm = ({ projectId, title, drNumber, onChange }) => {
  const [state, setState] = useState({ projectId, title, drNumber })

  useEffect(() => {
    onChange(state)
  }, [state, onChange])

  return (
    <>
      <p>You are creating a new project by copying existing one's content.</p>

      {!projectId && <p>Please provide ID of the project you want to copy and a new title.</p>}
      <Form>
        <FormItem label='Project to duplicate'>
          <Textfield
            defaultValue={projectId}
            onChange={v => setState(s => ({ ...s, projectId: v }))}
            disabled={!!projectId}
          />
        </FormItem>
        <FormItem label='Title for new project'>
          <Textfield defaultValue={title} onChange={v => setState(s => ({ ...s, title: v }))} />
        </FormItem>
        <FormItem label='DR Number'>
          <DealRegistrationInput defaultValue={drNumber} onChange={v => setState(s => ({ ...s, drNumber: v }))} />
        </FormItem>
      </Form>
    </>
  )
}
